<div class="toast-body" [style.display]="state() === 'inactive' ? 'none' : ''">
    <div class="toast-icon-wrap">
        <span [class]="toastIcon"></span>
    </div>
    <div class="toast-text">
        @if (title()) {
            <div class="toast-headline" [attr.aria-label]="title()">{{ title() }}</div>
        }
        @if (message()) {
            @if (options().enableHtml) {
                <div class="toast-detail" role="alert" [innerHTML]="message()"></div>
            } @else {
                <div class="toast-detail" role="alert" [attr.aria-label]="message()">{{ message() }}</div>
            }
        }
    </div>
    @if (options().closeButton) {
        <button class="toast-close" (click)="remove()" aria-label="Dismiss">
            <span class="mdi mdi-close"></span>
        </button>
    }
</div>

@if (options().progressBar) {
    <div>
        <div class="toast-progress" [style.width]="width + '%'"></div>
    </div>
}
